/**
 * LocationMap — the "Location" section: an address line plus a Google-maps
 * embed (or the map.svg placeholder when the offer has neither a mapUrl nor a
 * location). Split out of PropertyInfo so it can sit in the card's bottom
 * "tail" row: under the main info on desktop, and under the right column
 * (Property Details + Energy) on mobile — i.e. after Features, before the map.
 *
 * Props: offer (uses offer.location, offer.mapUrl)
 */
import React from 'react';
import { useStrings } from './i18n';
import { pinnedEmbedUrl } from './maps';
import { IconMapPin } from './icons';
import { asset } from './assets';

export default function LocationMap({ offer }) {
    const t = useStrings();
    return (
        <section className="rs-section">
            <div className="rs-location">
                <h2 className="rs-section__h">{t.location}</h2>
                <div className="rs-location__addr"><IconMapPin /> {offer.location}</div>
                {/* Ratio comes from the wrapper's padding (relative to its width),
                    not aspect-ratio — an <iframe> has no intrinsic size, and older
                    iOS Safari doesn't size it from aspect-ratio, so the map
                    collapsed to 0 height and vanished. */}
                <div className="rs-map-wrap">
                    {offer.mapUrl || offer.location ? (
                        <iframe
                            className="rs-map"
                            title={offer.location || t.location}
                            src={pinnedEmbedUrl(offer.mapUrl, offer.location)}
                            style={{ border: 0 }}
                            allowFullScreen=""
                            frameBorder="0"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    ) : (
                        <img className="rs-map" src={asset('prototype/map.svg')} alt={t.location} />
                    )}
                </div>
            </div>
        </section>
    );
}
